"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const color_const_1 = __importDefault(require("../choices/color.const"));
const graphics = {
    ghostly: {
        background: color_const_1.default.surfaceLight50,
    },
    workingDesk: {
        background: 'transparent',
    },
    clock: {
        background: color_const_1.default.cloudyBlue100,
    },
    incomingCall: {
        background: color_const_1.default.white,
    },
};
exports.default = graphics;
